import { render, staticRenderFns } from "./DFRSageReport.vue?vue&type=template&id=37d53568&scoped=true"
import script from "./DFRSageReport.vue?vue&type=script&lang=js"
export * from "./DFRSageReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d53568",
  null
  
)

export default component.exports